export default () => ({
  title: 'BloqCloud Console',
  pendingTasks: 0,
  showMenu: true,
  showSessionMenu: false,
  notifications: [],
  profile: {},
  userPlans: [],
  clusters: [],
  nodes: [],
  projectsToggle: [],
  sort: {
    startedClusters: { sortBy: 'createdAt', sortOrder: 'DESC' },
    stoppedClusters: { sortBy: 'stoppedAt', sortOrder: 'DESC' },
    startedNodes: { sortBy: 'createdAt', sortOrder: 'DESC' },
    stoppedNodes: { sortBy: 'stoppedAt', sortOrder: 'DESC' },
    invoices: { sortBy: 'createdAt', sortOrder: 'DESC' },
    keys: { sortBy: 'createdAt', sortOrder: 'DESC' },
    projects: { sortBy: 'createdAt', sortOrder: 'DESC' }
  }
})
